import { parseISO } from "date-fns";

interface ApiResponse {
  slots?: string[]; // NEW: normalized, preferred
  availableTimes?: {
    meetingTimeSlot?: {
      start?: {
        dateTime: string;
        timeZone?: string;
      };
    };
  }[];
}

export async function getAvailableSlots(
  date: string,
  duration: number = 60
): Promise<string[]> {
  try {
    const response = await fetch("/api/graph/calendar/availability", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ date, duration }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Failed to fetch available slots: ${response.statusText} - ${errorText}`
      );
    }

    const data: ApiResponse = await response.json();

    // ✅ Preferred path: already-normalized slots
    if (Array.isArray(data.slots)) {
      return data.slots;
    }

    // ⚠️ Backward compatibility fallback only
    if (!Array.isArray(data.availableTimes)) {
      throw new Error("Invalid API response: no slots or availableTimes.");
    }

    return data.availableTimes
      .map((suggestion) => {
        const start = suggestion?.meetingTimeSlot?.start?.dateTime;
        if (!start) return null;

        const parsed = parseISO(start);
        if (isNaN(parsed.getTime())) return null;

        // No timezone manipulation here — display only
        return parsed.toLocaleString("en-GB", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        }).replace(" ", "");
      })
      .filter((s): s is string => Boolean(s));
  } catch (error) {
    console.error("Error in getAvailableSlots:", error);
    throw error;
  }
}
